/* global axios */
import ApiClient from './ApiClient';

class EmpresaDocuments extends ApiClient {
  constructor() {
    super('documents', { accountScoped: true });
    this.empresaId = null;
  }

  get url() {
    return `${this.baseUrl()}/empresas/${this.empresaId}/documents`;
  }

  get(empresaId) {
    this.empresaId = empresaId;
    return super.get();
  }

  upload(empresaId, file) {
    this.empresaId = empresaId;
    const formData = new FormData();
    formData.append('document', file);
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  delete(empresaId, id) {
    this.empresaId = empresaId;
    return super.delete(id);
  }
}

export default new EmpresaDocuments();
